import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';
import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link.tsx';
import styles from './styles/ShopBreadcrumbs.scss';

function ShopBreadcrumbsComponent({ landingPage }) {
    return (
        <div className={styles.wrapper}>
            <Link className={styles.breadcrumbLink} href="/">
                <FormattedMessage defaultMessage="Home" id="ShopBreadcrumbs.home" />
            </Link>
            <span className={styles.breadcrumb}>{landingPage.title}</span>
        </div>
    );
}

ShopBreadcrumbsComponent.propTypes = {
    landingPage: PropTypes.object.isRequired,
};

export const ShopBreadcrumbs = createFragmentContainer(ShopBreadcrumbsComponent, {
    landingPage: graphql`
        fragment ShopBreadcrumbs_landingPage on LandingPage {
            title
        }
    `,
});
